import { WHITE_LABEL_BRAND } from '@/lib/white-label';
import { BadgeCheck } from 'lucide-react';
import { Tooltip } from 'react-tooltip';

export const PartnerCheck = ({
  name,
  size = 36,
}: {
  name?: string;
  size?: number;
}) => {
  return (
    <>
      <BadgeCheck
        className="fill-primary"
        size={size}
        data-tooltip-content={`Partnered with ${WHITE_LABEL_BRAND}`}
        data-tooltip-id={`${name}-partner-tooltip`}
        color={'#FFFFFF'}
      />
      {name && <Tooltip id={`${name}-partner-tooltip`} place="left" />}
    </>
  );
};
